import { render, staticRenderFns } from "./CommentsSkeletonLoader.vue?vue&type=template&id=6a3702e2&scoped=true"
import script from "./CommentsSkeletonLoader.vue?vue&type=script&lang=ts"
export * from "./CommentsSkeletonLoader.vue?vue&type=script&lang=ts"
import style0 from "./CommentsSkeletonLoader.vue?vue&type=style&index=0&id=6a3702e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3702e2",
  null
  
)

export default component.exports